import * as React from "react";
import SnackBar from "@tunnel-components/@sharded/@widgets/snack-bar/succees/component";
import BoxGrid from "@tunnel-components/@sharded/widgets/box/custom/component";
// import * as Utils from '@Cyclope-Utils/index';
// import * as Enums from '@tunnel-enums/index';
import * as i18next from "i18next";
// import * as cx from 'classnames';
import * as Styled from "@tunnel-components/@sharded/@styled/cart";
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    onChangeUser,
    onSubmitUser,
    isVisible,
    rightdata,
    onOpenModal,
    someInputError,
    roleError,
    nameError,
    firstnameError,
    loginError,
    addUsersError,
    emailError,
    onChangeRoleUserAdd,
    loginUserAdd,
    nameUserAdd,
    firstNameUserAdd,
    emailUserAdd,
    roleUserAdd,
    error,
  } = props;

  ///  Simple Authorization + some operations

  /**
   * @description : retourne un objet
   * @const
   * @name User
   * @type { any  }
   */
  // const User: any = Utils.createdUserRoles();

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <StyledComponent.ModalContainer isVisible={isVisible}>
      <StyledComponent.ModalContainerInsider
        isVisible={isVisible}
        style={{
          overflow: "visible",
          width: "660px",
          backgroundColor: "unset",
        }}
      >
        {isVisible && (
          <BoxGrid
            title={i18next.t("ajouter un utilisateur")}
            onClose={onOpenModal}
            classNames="boderShadow changed-btn-pwd animated slideInDown"
            onSubmit={onSubmitUser}
            BtnTextSpan={i18next.t("valider")}
          >
            <Styled.CartContainer style={{ overflow: "hidden" }}>
              <div className="extractionInfo left">
                <div className="titleAction">
                  <h2>{i18next.t("nom")}: </h2>
                  <StyledComponent.Container>
                    <StyledComponent.ContainerInput error={nameError}>
                      <StyledComponent.Input
                        type="text"
                        name="nameUserAdd"
                        value={nameUserAdd}
                        autoComplete="off"
                        onChange={onChangeUser}
                      />
                    </StyledComponent.ContainerInput>
                  </StyledComponent.Container>
                  <div>
                    {nameError && (
                      <span style={{ color: "#ed5b56", fontSize: "10px" }}>
                        {i18next.t("champ obligatoire / synthaxe invalide")}
                      </span>
                    )}
                  </div>
                </div>
                <div className="titleAction">
                  <h2>{i18next.t("prenom")} : </h2>
                  <StyledComponent.Container>
                    <StyledComponent.ContainerInput error={firstnameError}>
                      <StyledComponent.Input
                        type="text"
                        name="firstNameUserAdd"
                        value={firstNameUserAdd}
                        autoComplete="off"
                        onChange={onChangeUser}
                      />
                    </StyledComponent.ContainerInput>
                  </StyledComponent.Container>
                  <div>
                    {firstnameError && (
                      <span style={{ color: "#ed5b56", fontSize: "10px" }}>
                        {i18next.t("champ obligatoire / synthaxe invalide")}
                      </span>
                    )}
                  </div>
                </div>
                <div className="titleAction">
                  <h2>{i18next.t("login")} : </h2>
                  <StyledComponent.Container>
                    <StyledComponent.ContainerInput error={loginError}>
                      <StyledComponent.Input
                        type="text"
                        name="loginUserAdd"
                        value={loginUserAdd}
                        autoComplete="off"
                        onChange={onChangeUser}
                      />
                    </StyledComponent.ContainerInput>
                  </StyledComponent.Container>
                  <div>
                    {loginError && (
                      <span style={{ color: "#ed5b56", fontSize: "10px" }}>
                        {" "}
                        {i18next.t("champ obligatoire / synthaxe invalide")}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="extractionInfo left">
                <div className="titleAction">
                  <h2>{i18next.t("email")} : </h2>
                  <StyledComponent.Container>
                    <StyledComponent.ContainerInput error={emailError}>
                      <StyledComponent.Input
                        type="email"
                        name="emailUserAdd"
                        value={emailUserAdd}
                        autoComplete="off"
                        onChange={onChangeUser}
                      />
                    </StyledComponent.ContainerInput>
                  </StyledComponent.Container>
                  <div>
                    {emailError && (
                      <span style={{ color: "#ed5b56", fontSize: "10px" }}>
                        {" "}
                        {i18next.t("email invalide / synthaxe invalide")}
                      </span>
                    )}
                  </div>
                </div>
                <div className="titleAction">
                  <h2>{i18next.t("role")}: </h2>
                  <select
                    style={{ color: "#88898a" }}
                    name="roleuserAdd"
                    id="roleUserAdd"
                    multiple={true}
                    className="selectRoleMultiple"
                    placeholder={i18next.t("superviseur")}
                    value={roleUserAdd}
                    onChange={onChangeRoleUserAdd}
                  >
                    {rightdata &&
                      rightdata.map((elem: any, index: number) => (
                        <option key={index} value={elem}>
                          {" "}
                          {i18next.t(elem)}
                        </option>
                      ))}
                  </select>
                  {roleError && (
                    <span style={{ color: "#ed5b56", fontSize: "10px" }}>
                      {" "}
                      {i18next.t("champ obligatoire")}
                    </span>
                  )}
                </div>
                <div className="titleAction">
                  <h2 />
                </div>
              </div>
            </Styled.CartContainer>
          </BoxGrid>
        )}
      </StyledComponent.ModalContainerInsider>

      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={addUsersError}
        someTextSuccees={i18next.t("impossible de créer cet utilisateur")}
      />
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={someInputError}
        someTextSuccees={i18next.t("synthaxe invalide / champ obligatoire")}
      />
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={error}
        someTextSuccees={i18next.t("impossible de créer un utilisateur")}
      />
    </StyledComponent.ModalContainer>
  );
};
/** Valeurs par défaut des props */
Component.defaultProps = {
  emailUserAdd: "",
  firstNameUserAdd: "",
  loginUserAdd: "",
  nameUserAdd: "",
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  loading?: any;
  onOpenModal?: any;
  nameUserAdd?: any;
  firstNameUserAdd?: any;
  emailUserAdd?: any;
  roleUserAdd?: any;
  error?: any;
  onChangeRoleUserAdd?: any;
  onChangeUser?: any;
  onSubmitUser?: any;
  loginUserAdd?: any;
  someInputError?: any;
  emailError?: any;
  addUsersError?: any;
  roleError?: any;
  nameError?: any;
  firstnameError?: any;
  loginError?: any;
  isVisible?: boolean;
  rightdata?: any;
}
/** @export HOC pure */
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/modal/users/creation/component.tsx